module.exports = __webpack_public_path__ + "img/statue-of-liberty.36e06a50.jpg";